<template>
  <div class="q-pt-md">
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      :filter="filter"
      :rows="rows"
      :columns="columns"
      :loading="disable"
      v-model:pagination="pagination"
      hide-pagination
      dense
      class="tabela-tamanho-fixo"
      @request="handleRequest"
    >
      <template v-slot:top-right>
        <q-input
          outlined
          rounded
          dense
          debounce="300"
          v-model="filter"
          placeholder="Buscar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template #body-cell-created_at="props">
        <q-td>
          {{
            props.row.created_at?.split(" ")[0]?.split("-")?.reverse().join("/")
          }}
          {{ props.row.created_at?.split(" ")[1] }}
        </q-td>
      </template>
      <template #body-cell-name="props">
        <q-td>
          <q-input
            v-if="props.row.editar == true"
            dense
            outlined
            v-model="props.row.name"
          />
          <span v-else>{{ props.row.name }}</span>
        </q-td>
      </template>
      <template #body-cell-description="props">
        <q-td>
          <q-input
            v-if="props.row.editar == true"
            dense
            outlined
            v-model="props.row.description"
          />
          <span v-else>{{ props.row.description }}</span>
        </q-td>
      </template>
      <template #body-cell-modificar="props">
        <q-td>
          <q-btn
            v-if="!props.row.editar"
            color="secondary"
            round
            class="q-ml-sm"
            icon="edit"
            @click="props.row.editar = true"
          />
          <q-btn
            v-else
            color="positive"
            round
            class="q-ml-sm"
            icon="done"
            @click="editar(props.row)"
          />
        </q-td>
      </template>
      <template #body-cell-image="props">
        <q-td>
          <q-img
            v-if="props.row.images[0]"
            :src="props.row.images[0].url"
            spinner-color="white"
            height="65px"
            width="95px"
            fit="contain"
            no-native-menu
          />
          <q-btn
            v-if="props.row.images[0]"
            color="negative"
            round
            icon="close"
            @click="deleteImage(props.row.images[0].id)"
          />
          <q-file
            v-else
            label="Selecione a imagem"
            outlined
            dense
            v-model="file"
            @click="ingetId(props.row.id)"
            style="width: 150px"
          >
            <template v-slot:prepend>
              <q-icon name="attach_file" />
            </template>
          </q-file>
        </q-td>
      </template>
      <template #body-cell-produtos="props">
        <q-td>
          <q-btn
            color="primary"
            round
            class="q-ml-sm"
            icon="add"
            @click="
              routeProdutos(
                props.row.id,
                props.row.name,
                'grupo-produtos-adicionar'
              )
            "
          />
        </q-td>
      </template>
      <template #body-cell-unidade="props">
        <q-td>
          <q-btn
            color="primary"
            round
            class="q-ml-sm"
            icon="apartment"
            @click="
              routeProdutos(
                props.row.id,
                props.row.name,
                'grupo-produtos-regras'
              )
            "
          />
        </q-td>
      </template>
      <template #body-cell-centro="props">
        <q-td>
          <q-btn
            color="primary"
            round
            class="q-ml-sm"
            icon="business_center"
            @click="
              routeProdutos(
                props.row.id,
                props.row.name,
                'grupo-produtos-centro'
              )
            "
          />
        </q-td>
      </template>
      <template #body-cell-processos="props">
        <q-td>
          <q-btn
            color="primary"
            round
            class="q-ml-sm"
            icon="account_tree"
            @click="
              routeProdutos(
                props.row.id,
                props.row.name,
                'grupo-produtos-processo'
              )
            "
          />
        </q-td>
      </template>
      <template #body-cell-pessoas="props">
        <q-td>
          <q-btn
            color="primary"
            round
            class="q-ml-sm"
            icon="person"
            @click="
              routeProdutos(
                props.row.id,
                props.row.name,
                'grupo-produtos-pessoas'
              )
            "
          />
        </q-td>
      </template>
      <template #body-cell-deletar="props">
        <q-td>
          <q-btn
            color="negative"
            round
            class="q-ml-sm"
            icon="delete"
            @click="abrirModalDeletar(props.row.id)"
          />
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>

    <DialogConfirmDesign
      :mensagem="modalDeletar.mensagem"
      :exibir="modalDeletar.exibir"
      :titulo="modalDeletar.titulo"
      @resultado="confirmarDeletar"
    />
  </div>
</template>

<script>
const columns = [
  {
    name: "id",
    label: "ID",
    field: "id",
    align: "left",
  },
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
  },
  {
    name: "description",
    label: "Descrição",
    field: "description",
    align: "left",
  },
  {
    name: "created_at",
    label: "Criado em",
    field: "created_at",
    align: "left",
  },
  {
    name: "image",
    label: "Imagem",
    field: "image",
    align: "left",
  },
  {
    name: "modificar",
    label: "Modificar",
    field: "modificar",
    align: "left",
  },
  {
    name: "produtos",
    label: "Produtos",
    field: "produtos",
    align: "left",
  },
  {
    name: "unidade",
    label: "Unidades",
    field: "unidade",
    align: "left",
  },
  {
    name: "centro",
    label: "Centros de Custo",
    field: "centro",
    align: "left",
  },
  {
    name: "processos",
    label: "Processos",
    field: "processos",
    align: "left",
  },
  {
    name: "pessoas",
    label: "Pessoas",
    field: "pessoas",
    align: "left",
  },
  {
    name: "deletar",
    label: "Deletar",
    field: "deletar",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useQuasar } from "quasar";
import DialogConfirmDesign from "../../../../components/DialogConfirmDesign.vue";

export default {
  components: {
    DialogConfirmDesign,
  },
  setup() {
    const $q = useQuasar();
    const router = useRouter();
    const store = useStore();
    const rows = ref([]);
    const disable = ref(true);
    let filter = ref("");
    const file = ref(undefined);
    const product_group_id = ref("");
    const contrato = ref({});
    const listaContratosOptions = ref([]);

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    const modalDeletar = ref({
      exibir: false,
      mensagem: "",
      titulo: "Confirmar Exclusão",
      grupoId: null,
    });

    const getGrupos = async (page = 1, rowsPerPage = 15) => {
      if (contrato.value?.id == undefined) {
        return;
      }

      let response = await store.dispatch("grupoProdutos/listarGrupos", {
        unidade: contrato.value.id,
        per_page: rowsPerPage,
        page: page,
        search: filter.value,
      });

      rows.value = response.data.results.data;
      pagination.value.rowsPerPage = response.data.results.per_page;
      pagination.value.rowsNumber = response.data.results.total;
      pagination.value.page = response.data.results.current_page;

      disable.value = false;
    };

    onMounted(async () => {
      await listarContratos();
      getGrupos();
    });

    const listarContratos = async () => {
      console.log(store.state.org.unidadeData.id);
      if (store.state.org.unidadeData.id == undefined) {
        return;
      }
      try {
        const response = await store.dispatch("requisicao/listarContratos", {
          per_page: 100,
        });
        let array = response.data.results.data;
        listaContratosOptions.value = [];
        array.forEach((contrato) => {
          listaContratosOptions.value.push({
            label: contrato?.contract?.description,
            id: contrato?.pivot?.vendor_id,
          });
        });
        selecionarContrato();
      } catch (error) {
        console.log(error);
      }
    };

    const selecionarContrato = () => {
      let valor = listaContratosOptions.value.filter((contrato) => {
        return contrato.id == store.state.org.unidadeData.id;
      });
      contrato.value = valor[0];
    };

    const deleteImage = async (id) => {
      try {
        await store.dispatch("grupoProdutos/removerImagem", {
          id,
        });

        $q.notify({
          message: "Imagem deletada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getGrupos();
      } catch (error) {
        $q.notify({
          message: "Erro a o deletar imagem",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const routeProdutos = async (id, name, rota) => {
      let dados = { id: id, nome: name };

      router.push({
        name: `${rota}`,
        params: { id: JSON.stringify(dados) },
      });
    };

    const abrirModalDeletar = (id) => {
      modalDeletar.value.grupoId = id;
      modalDeletar.value.mensagem = "Tem certeza que deseja deletar esse Grupo?";
      modalDeletar.value.exibir = true;
    };

    const confirmarDeletar = async (confirmado) => {
      modalDeletar.value.exibir = false;

      if (!confirmado) {
        modalDeletar.value.grupoId = null;
        return;
      }

      const id = modalDeletar.value.grupoId;

      try {
        await store.dispatch("grupoProdutos/removerLinha", {
          id,
        });

        $q.notify({
          message: "Linha deletada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getGrupos();
      } catch (error) {
        $q.notify({
          message: "Erro ao deletar linha",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }

      modalDeletar.value.grupoId = null;
    };

    const adicionarImage = async () => {
      var reader = new FileReader();
      reader.readAsDataURL(file.value);
      reader.onload = async function () {
        try {
          await store.dispatch("grupoProdutos/adicionarImagem", {
            image: reader.result,
            product_group_id: product_group_id.value,
          });

          $q.notify({
            message: "Imagem enviada com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });

          file.value = "";
          getGrupos();
        } catch (error) {
          $q.notify({
            message: "Erro a o enviar imagem",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      };
    };

    const editar = async (dados) => {
      try {
        await store.dispatch("grupoProdutos/editarGrupo", {
          id: dados.id,
          name: dados.name,
          description: dados.description,
        });

        $q.notify({
          message: "Editado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getGrupos();
      } catch (error) {
        $q.notify({
          message: "Erro a o editar linha",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const handleRequest = async () => {
      getGrupos(pagination.value.page, pagination.value.rowsPerPage);
    };

    const ingetId = async (id) => {
      product_group_id.value = id;
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => file.value,
      () => {
        adicionarImage();
      }
    );

    watch(
      () => contrato.value,
      () => {
        getGrupos();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        listarContratos();
      }
    );

    return {
      columns,
      rows,
      getGrupos,
      pagination,
      handleRequest,
      disable,
      file,
      filter,
      deleteImage,
      adicionarImage,
      ingetId,
      abrirModalDeletar,
      confirmarDeletar,
      modalDeletar,
      routeProdutos,
      listarContratos,
      contrato,
      listaContratosOptions,
      selecionarContrato,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      editar,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.circle {
  width: 12px;
  height: 12px;

  border-radius: 50%;
}

.align {
  align-items: center;
}
</style>
